import React from 'react';
import About from '../components/About';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <>
      <SEO
        title="Hakkımızda"
        description="LYSEP CORPORATION hakkında bilgi edinin. Teknoloji ve inovasyonun öncüsü olarak, geleceği şekillendiren çözümler sunuyoruz. Misyonumuz, vizyonumuz ve değerlerimiz."
        keywords="LYSEP hakkında, şirket tanıtımı, misyon, vizyon, teknoloji firması, yazılım şirketi, inovasyon"
        path="/about"
      />
      <About />
    </>
  );
};

export default AboutPage;

